import script from "./LKProjectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LKProjectModal.vue?vue&type=script&setup=true&lang=js"

import "./LKProjectModal.vue?vue&type=style&index=0&id=db47cbde&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db47cbde"]])

export default __exports__